import calendarHu from "./calendarHu";
import commonHu from "./commonHu";
import eventsHu from "./eventsHu";
import authHu from "./authHu";
import filtersHu from "./filtersHu";
import knowledgebaseHu from "./knowledgebaseHu";
import settingsHu from "./settingsHu";
import reservationHu from "./reservationHu";
import validationHu from "./validationHu";
import errorsHu from "./errorsHu";
import groupReservation from "./groupReservation";
import waitlistHu from "./waitlistHu";
import statisticsHu from "./statisticsHu";

const mainHu = {
    common: commonHu,
    calendar: calendarHu,
    events: eventsHu,
    auth: authHu,
    filters: filtersHu,
    knowledgebase: knowledgebaseHu,
    settings: settingsHu,
    reservation: reservationHu,
    validation: validationHu,
    error: errorsHu,
    group_reservation: groupReservation,
    waitlist: waitlistHu,
    statistics: statisticsHu,
}

export default mainHu;